import { Feature } from "ol"
import { Point } from "ol/geom"
import { VectorImage, Vector as VectorLayer } from "ol/layer"
import { WebGLPoints as WebGLPointsLayer } from "ol/layer"
import { Vector as VectorSource } from "ol/source"
import { Circle, Fill, Icon, Stroke, Style } from "ol/style"

//local
import sysIconsConf from '@/components/Map/layers/utils/sysIconsConf'
/**
 * 帮助添加icon
 * @param {*} map 
 * @param {*} layer 
 * @returns 
 */
export function createIconHelper(map, layer, options) {
    if (!layer) {
        layer = new VectorLayer({ source: new VectorSource({ wrapX: true }) })
        layer.setZIndex(10)
        map.addLayer(layer)
    }
    let source = layer.getSource()
    // 用于处理一些交互，悬浮、点击
    let hoverHandles = new Map()
    let hoverFeatures = []
    let leaveHandles = []
    let clickHandles = new Map()
    let focusFeatures = []
    let blurHandles = []
    let layerFilter = lay => lay instanceof VectorLayer || lay instanceof WebGLPointsLayer
    if (options && options.onlySelf) {
        layerFilter = lay => lay == layer
    }

    let canPointMove = true
    let canClick = true
    let stopIconEvent = (name) => {
        if (name == "pointermove") {
            canPointMove = false
        } else if (name == "click") {
            canClick = false
        } else if (name === undefined) {
            canPointMove = canClick = false
        }
    }
    let restoreIconEvent = (name) => {
        if (name == "pointermove") {
            canPointMove = true
        } else if (name == "click") {
            canClick = true
        } else if (name === undefined) {
            canPointMove = canClick = true
        }
    }
    map.getTarget().addEventListener("mouseout", (e) => {
        if (canPointMove) {

            dispatchEvent("leave", e, {})
        }

    })
    map.on("pointermove", (e) => {
        if (!canPointMove) return
        if (map.getView().getInteracting() || map.getView().getAnimating()) {
            return;
        }
        let feature_ = map.forEachFeatureAtPixel(e.pixel, function (f) {
            return f;
        }, { layerFilter, hitTolerance: 15 })
        if (feature_) {

            dispatchEvent("hover", e, { feature_ })


        } else {
            dispatchEvent("leave", e, {})
        }

    })
    map.on("click", (e) => {
        if (!canClick) return
        let feature_ = map.forEachFeatureAtPixel(e.pixel, function (f) {
            return f;
        }, { layerFilter });
        //   点击到feature
        if (feature_) {
            setImmediate(() => {

                dispatchEvent("focus", e, { feature_ })
            })


        } else {
            //   什么也没点击到
            dispatchEvent("blur", e, {})
        }

    })
    /**
     * 发送事件，触发注册的回调
     * @param {*} type 
     * @param {*} originalEvent 
     */
    let dispatchEvent = (eType, originalEvent, args) => {
        let { feature_ } = args
        let type, handles;
        switch (eType) {
            case "hover":
                type = getFeaturesType(feature_)

                handles = hoverHandles.get(type)
                if (handles) {
                    handles.forEach(f => {
                        f(originalEvent, feature_, hoverFeatures, focusFeatures, { map, layer, source })
                    })
                }
                // 数组情况
                if (Array.isArray(feature_)) {

                    hoverFeatures = hoverFeatures.concat(feature_)
                } else {
                    hoverFeatures.push(feature_)
                }

                break;
            case "leave":
                leaveHandles.forEach(f => {
                    f(originalEvent, hoverFeatures, focusFeatures, { map, layer, source })
                })
                // hoverFeatures = []
                break;
            case "focus":
                type = getFeaturesType(feature_)
                handles = clickHandles.get(type)
                if (handles) {
                    handles.forEach(f => {
                        f(originalEvent, feature_, focusFeatures, { map, layer, source })
                    })
                }
                if (Array.isArray(feature_)) {

                    focusFeatures = focusFeatures.concat(feature_)
                } else {
                    focusFeatures.push(feature_)
                }

                break;
            case "blur":
                blurHandles.forEach(f => {
                    f(originalEvent, focusFeatures, { map, layer, source })
                })
                // focusFeatures = []
                break;
        }
    }
    let addIcon = (coord, iconOptions, type, data) => {
        let point = new Point(coord)
        let feature = new Feature(point)
        if (iconOptions) {
            if (iconOptions.asCircle && iconOptions.radius) {
                let style = new Style({
                    image: new Circle({
                        radius: iconOptions.radius,
                        stroke: new Stroke({
                            color: iconOptions.strokeColor || "#000000",
                            width: iconOptions.strokeWidth || 3,
                        }),
                        fill: new Fill({
                            color: iconOptions.fillColor || "red"
                        })
                    }),
                })
                feature.setStyle(style)
            } else if (iconOptions.src) {
                let style = new Style({
                    image: new Icon(iconOptions)
                })
                feature.setStyle(style)
            }
        }


        //非必须设置feature 类型
        feature.set("info", data)
        feature.set("type", type)
        source.addFeature(feature)
        return feature
    }
    // 移除一个或多个图标
    let removeIcon = (feature) => {
        try {
            if (Array.isArray(feature)) {

                feature.forEach(fea => {
                    if (source.hasFeature(fea)) {

                        source.removeFeature(fea)
                    }
                })
            } else {
                if (source.hasFeature(feature)) {

                    source.removeFeature(feature)
                }

            }
        } catch (error) {

        }

    }
    let onHoverIcon = (type, func) => {
        if (typeof func != "function") return false;
        let handles = hoverHandles.get(type)
        if (!handles) {
            handles = []
            hoverHandles.set(type, handles)
        }
        handles.push(func)
        return true

    }
    // 取消监听的，需要再增加
    let unHoverIcon = (type, func) => {
        if (typeof func != "function") return true;
        let handles = hoverHandles.get(type)
        if (!handles) return true
        let idx = handles.indexOf(func)
        if (idx == -1) return true
        handles.splice(idx, 1)
        return true
    }

    let onLeaveIcon = (func) => {
        if (typeof func != "function") return false;
        leaveHandles.push(func)
        return true

    }
    let onClickIcon = (type, func) => {
        if (typeof func != "function") return false;
        let handles = clickHandles.get(type)
        if (!handles) {
            handles = []
            clickHandles.set(type, handles)
        }
        handles.push(func)
        return true

    }
    let onBlurIcon = (func) => {
        if (typeof func != "function") return false;
        blurHandles.push(func)
        return true

    }
    let getParams = () => {
        return { map, layer, source, hoverFeatures, focusFeatures }
    }

    let clear = () => {
        source.clear()
    }
    return { addIcon, removeIcon, clear, onHoverIcon, onLeaveIcon, onClickIcon, onBlurIcon, getParams, dispatchEvent, stopIconEvent, restoreIconEvent, raw: true }
}

export function createWebglIconHelper(map, layer, options) {

    let symbol = options.symbol ? options.symbol : {
        symbolType: 'triangle',
        size: ["get", "glStyle_size"],
        rotation: ["get", "glStyle_rotation"],
        color: ['color', ["get", "glStyle_color_r"],
            ["get", "glStyle_color_g"],
            ["get", "glStyle_color_b"],
            ["get", "glStyle_color_a"]
        ],
        rotateWithView: true,
    }
    if (!layer) {
        const style = {
            symbol

        }
        // sysIconsConf.SHIPICON_N
        // const style = {
        //     symbol: {
        //         symbolType: "image",
        //         rotation: ["get", "glStyle_rotation"],
        //         // src: ["match", 0, 1, sysIconsConf.SHIPICON_V, 0, sysIconsConf.SHIPICON_N, sysIconsConf.SHIPICON_N],
        //         src: ["case", true, sysIconsConf.SHIPICON_N],
        //         size: [
        //             18,
        //             28
        //         ],
        //         rotateWithView: false,
        //         offset: [
        //             0,
        //             9
        //         ]
        //     }
        // }
        layer = new WebGLPointsLayer({ source: new VectorSource({ wrapX: true }), style, disableHitDetection: false })
        layer.setZIndex(10)
        map.addLayer(layer)
    }
    let source = layer.getSource()
    // 用于处理一些交互，悬浮、点击
    let hoverHandles = new Map()
    let hoverFeatures = []
    let leaveHandles = []
    let clickHandles = new Map()
    let focusFeatures = []
    let blurHandles = []
    let layerFilter = lay => lay instanceof VectorLayer || lay instanceof WebGLPointsLayer
    if (options && options.onlySelf) {
        layerFilter = lay => lay == layer
    }

    let canPointMove = true
    let canClick = true
    let stopIconEvent = (name) => {
        if (name == "pointermove") {
            canPointMove = false
        } else if (name == "click") {
            canClick = false
        } else if (name === undefined) {
            canPointMove = canClick = false
        }
    }
    let restoreIconEvent = (name) => {
        if (name == "pointermove") {
            canPointMove = true
        } else if (name == "click") {
            canClick = true
        } else if (name === undefined) {
            canPointMove = canClick = true
        }
    }
    map.getTarget().addEventListener("mouseout", (e) => {
        if (canPointMove) {

            dispatchEvent("leave", e, {})
        }

    })
    map.on("pointermove", (e) => {
        if (!canPointMove) return
        let feature_ = map.forEachFeatureAtPixel(e.pixel, function (f) {
            return f;
        }, { layerFilter })
        if (feature_) {

            dispatchEvent("hover", e, { feature_ })


        } else {
            dispatchEvent("leave", e, {})
        }

    })
    map.on("click", (e) => {
        if (!canClick) return
        let feature_ = map.forEachFeatureAtPixel(e.pixel, function (f) {
            return f;
        }, { layerFilter });
        //   点击到feature
        if (feature_) {

            dispatchEvent("focus", e, { feature_ })


        } else {
            //   什么也没点击到
            dispatchEvent("blur", e, {})
        }

    })
    /**
     * 发送事件，触发注册的回调
     * @param {*} type 
     * @param {*} originalEvent 
     */
    let dispatchEvent = (eType, originalEvent, args) => {
        let { feature_ } = args
        let type, handles;
        switch (eType) {
            case "hover":
                type = getFeaturesType(feature_)

                handles = hoverHandles.get(type)
                if (handles) {
                    handles.forEach(f => {
                        f(originalEvent, feature_, hoverFeatures, focusFeatures, { map, layer, source })
                    })
                }
                // 数组情况
                if (Array.isArray(feature_)) {

                    hoverFeatures = hoverFeatures.concat(feature_)
                } else {
                    hoverFeatures.push(feature_)
                }

                break;
            case "leave":
                leaveHandles.forEach(f => {
                    f(originalEvent, hoverFeatures, focusFeatures, { map, layer, source })
                })
                break;
            case "focus":
                type = getFeaturesType(feature_)
                handles = clickHandles.get(type)
                if (handles) {
                    handles.forEach(f => {
                        f(originalEvent, feature_, focusFeatures, { map, layer, source })
                    })
                }
                if (Array.isArray(feature_)) {

                    focusFeatures = focusFeatures.concat(feature_)
                } else {
                    focusFeatures.push(feature_)
                }

                break;
            case "blur":
                blurHandles.forEach(f => {
                    f(originalEvent, focusFeatures, { map, layer, source })
                })
                break;
        }
    }
    let addIcon = (coord, iconOptions, type, data) => {
        let point = new Point(coord)
        let feature = new Feature(point)
        if (iconOptions && iconOptions.src) {

            let style = new Style({
                image: new Icon(iconOptions),

            })
            feature.setStyle(style)
        }
        //非必须设置feature 类型
        feature.set("info", data)
        feature.set("type", type)
        source.addFeature(feature)
        return feature
    }
    // 移除一个或多个图标
    let removeIcon = (feature) => {
        try {
            if (Array.isArray(feature)) {

                feature.forEach(fea => {
                    if (source.hasFeature(fea)) {

                        source.removeFeature(fea)
                    }
                })
            } else {
                if (source.hasFeature(feature)) {

                    source.removeFeature(feature)
                }

            }
        } catch (error) {

        }

    }
    let onHoverIcon = (type, func) => {
        if (typeof func != "function") return false;
        let handles = hoverHandles.get(type)
        if (!handles) {
            handles = []
            hoverHandles.set(type, handles)
        }
        handles.push(func)
        return true

    }
    // 取消监听的，需要再增加
    let unHoverIcon = (type, func) => {
        if (typeof func != "function") return true;
        let handles = hoverHandles.get(type)
        if (!handles) return true
        let idx = handles.indexOf(func)
        if (idx == -1) return true
        handles.splice(idx, 1)
        return true
    }

    let onLeaveIcon = (func) => {
        if (typeof func != "function") return false;
        leaveHandles.push(func)
        return true

    }
    let onClickIcon = (type, func) => {
        if (typeof func != "function") return false;
        let handles = clickHandles.get(type)
        if (!handles) {
            handles = []
            clickHandles.set(type, handles)
        }
        handles.push(func)
        return true

    }
    let onBlurIcon = (func) => {
        if (typeof func != "function") return false;
        blurHandles.push(func)
        return true

    }
    let getParams = () => {
        return { map, layer, source, hoverFeatures, focusFeatures }
    }
    let clear = () => {
        source.clear()
    }

    return { addIcon, removeIcon, clear, onHoverIcon, onLeaveIcon, onClickIcon, onBlurIcon, getParams, dispatchEvent, stopIconEvent, restoreIconEvent }

}

function getFeaturesType(feature) {
    if (Array.isArray(feature)) {
        return getFeaturesType(feature[0])
    } else {
        return feature.get("type")
    }
}

/**
 * 四个默认方法用于自动实现hover leave focus blur等高亮切换效果
 * 参数与上面的dispatchEvent 的参数相同
 * 需要操作的feature 设置 feature.set("styles",{normalStyle,highStyle})
 * 代表feature 的高亮和普通样式
 */
export function defaultFocus(evt, feature, focusFeatures) {
    focusFeatures.forEach((fea) => {
        // if (equalOrContain(feature, fea)) return;
        let styles = fea.get("styles");
        if (styles) {
            let { normalStyle } = styles;
            // fea.setStyle(normalStyle);
            setFeatureStyle(fea, normalStyle)

        }
    });
    focusFeatures.length = 0;
    // 如果是数组的
    changeFeaturesStyle(feature)

}
/**
 * 改变Feature 的高亮状态
 * @param {*} features 
 * @param {*} highlight 
 */
function changeFeaturesStyle(features, highlight = true) {
    if (Array.isArray(features)) {
        features.forEach(fea => {
            let styles = fea.get("styles");
            if (styles) {
                let { normalStyle, highStyle } = styles;
                if (highlight) {

                    // fea.setStyle(highStyle);
                    setFeatureStyle(fea, highStyle)

                } else {
                    // fea.setStyle(normalStyle)
                    setFeatureStyle(fea, normalStyle)

                }
            }
        })
    } else {
        let styles = features.get("styles");
        if (styles) {
            let { normalStyle, highStyle } = styles;
            if (highlight) {
                // features.setStyle(highStyle);
                setFeatureStyle(features, highStyle)

            } else {
                // features.setStyle(normalStyle)
                setFeatureStyle(features, normalStyle)

            }
        }

    }
}

function equalOrContain(features, fea) {
    if (Array.isArray(features)) return features.includes(fea)
    return features == fea

}
/**
 * 可以设置普通和webglPointsLayer Feature 的style
 */
export function setFeatureStyle(feature, style) {
    let isWebgl = feature.get("isWebgl")
    if (!isWebgl) {
        feature.setStyle(style)
    } else {
        if (style) {
            //webgl的 通过键值对的方式保存,并且以gl_style开头
            setObjectStyle(feature, style, "glStyle")
        }

    }

}

function setObjectStyle(feature, style, prefix = "") {
    for (let key in style) {
        let st = style[key]
        if (typeof st == "object") {
            setObjectStyle(feature, st, prefix + "_" + key)
        } else {
            feature.set(prefix + "_" + key, st)

        }
    }
}
export function defaultHover(evt, feature, features, focusFeatures) {
    // 取消已有的高亮样式

    features.forEach((fea) => {
        if (focusFeatures.includes(fea)) {
            return
        };
        let styles = fea.get("styles");
        if (styles) {
            let { normalStyle } = styles;
            setFeatureStyle(fea, normalStyle)
        }
    });
    changeFeaturesStyle(feature)

    features.length = 0;
}
export function defaultLeave(evt, features, focusFeatures) {

    features.forEach((feature) => {
        let styles = feature.get("styles");
        if (styles) {
            if (!focusFeatures.includes(feature)) {
                let { normalStyle } = styles;
                setFeatureStyle(feature, normalStyle)

            }
        }
    });
    features.length = 0
}
export function defaultBlur() {

}


// WEBPACK FOOTER //
// ./src/pages/mapUtils/mapIcon.js